import * as React from "react";
import { clsx } from "clsx";
import { CircleLoader } from "@/components/ui/circleLoader";
import { PHASE_LABEL_WIDTH_CLASS } from "@/views/drive/modals/uploadModal/phaseLabels";
import colors from "tailwindcss/colors";

interface Props {
  progress: number;
  progressLabel: string;
}

export const DriveRowProgressbar: React.FC<Props> = ({ progress, progressLabel }) => {
  const normalizedProgressbar = progress.toFixed(0);
  return (
    <div className="mr-1 flex items-center gap-2">
      <CircleLoader fill={colors.gray[500]} />
      <span className="w-9 shrink-0 text-right text-xs tabular-nums">{normalizedProgressbar}%</span>
      <span className={clsx(PHASE_LABEL_WIDTH_CLASS, "shrink-0 truncate text-xs text-muted-foreground")}>
        {progressLabel}
      </span>
    </div>
  );
};
